import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Doug C. Hardester
 * id 79D47101-F8CB-496B-99B0-957DADED5D44
 * name wrap
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/wrap.svg
 * tags
 */
export const WrapIcon = createSvgIcon(<><path d="M21,5H3V7H21V5M3,19H10V17H3V19M3,13H18C19,13 20,13.43 20,15C20,16.57 19,17 18,17H16V15L12,18L16,21V19H18C20.95,19 22,17.73 22,15C22,12.28 21,11 18,11H3V13Z" /></>, 'WrapIcon');
export default WrapIcon